import { Color, HorizontalFlex, ListBody, ListHead, Space, TableScroller } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const SubTableStyled = styled(TableScroller)`
  padding: 0 ${Space.V4} !important;
`;

// The sub-table never shows its own header row - the export title cell already carries the label.
export const SubStyledTableHead = styled(ListHead)`
  display: none;
`;

export const SubStyledTableBody = styled(ListBody)`
  & [role="row"] {
    min-height: 44px;
    box-shadow: none !important;

    &:hover {
      box-shadow: none !important;
    }

    /* ListRow's cell wrapper isn't reachable via [role="cell"] and hard-codes 16px vertical padding. */
    & > div:first-child > div:first-child {
      padding-top: ${Space.V8};
      padding-bottom: ${Space.V8};
    }
  }
`;

export const IconBackground = styled(HorizontalFlex)`
  border-radius: ${Space.V8};
  background-color: ${Color.Neutral.V10};
  width: ${Space.V40};
  height: ${Space.V40};
  justify-content: center;
  align-items: center;
`;
